<template>
  <v-card :style="cardClass" class="ma-3">
    <info-tag label="CURRENT" class="ma-3" style="z-index: 100" />
    <chart
      type="pie"
      :data="data"
      :labels="labels"
      :options="options"
      :secondaryTitle="secondaryTitle"
      :overdue="overdue"
      elevation="0"
      :loading="loadingStates.screensOverview"
      :title="title"
      width="auto"
    >
    </chart>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import Chart from '@/components/charts/Chart';
import { MobileView } from '@/mixins';
import InfoTag from '../app/InfoTag.vue';

export default {
  components: {
    Chart,
    InfoTag,
  },
  props: [
    'type',
    'data',
    'labels',
    'title',
    'secondaryTitle',
    'options',
    'overdue',
  ],
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      client: 'account/getCurrentClient',
      loadingStates: 'home/getGraphLoadingStates',
    }),
    cardClass() {
      if (this.showMobileView) {
        return 'padding-bottom:10px;';
      }
      return 'overflow:hidden; min-height:100%; width:100%;';
    },
    chartWidth() {
      if (this.showMobileView) {
        return '';
      }
      return '500px';
    },
  },
};
</script>

<style></style>
